export default "__VITE_ASSET__Dearwlwl__"